export enum HostRoute {
    FACILISIGHT = 'FACILISIGHT',
    INTERNAL = 'INTERNAL'
}